

import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  mounted () {
    if (this.Tabs.length > 0) {
      this.$router.push(this.Tabs[0].Link as any)
    }
  },
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Security')
    },
    Tabs () {
      var Tabs = [
        { Name: this.Translate('Exports'), Link: '/Reports/Inventory/Exports', Access: this.Access('Inventory_Transfers_Read') },
        { Name: this.Translate('Imports'), Link: '/Reports/Inventory/Imports', Access: this.Access('Inventory_Transfers_Read') },
        { Name: this.Translate('External Import'), Link: '/Reports/Inventory/ExternalImports', Access: this.Access('Inventory_Transfers_Read') },
        { Name: this.Translate('Items'), Link: '/Reports/Inventory/Items', Access: this.Access('Inventory_Items_Read') }
      ] as Array<CookiesTabs>
      return Tabs.filter(tab => {
        return tab.Access
      })
    }
  },
  methods: {},
  watch: {}
})
